<template>
  <v-hover v-slot:default="{ hover }">
    <v-card
      :class="[
        'rounded-md',
        'v-cardgrid',
        'mx-auto',
        'mb-4',
        { 'on-hover': hover },
      ]"
      :elevation="hover ? 8 : 2"
      :max-width="width"
    >
      <slot></slot>
    </v-card>
  </v-hover>
</template>

<script>
export default {
    props:{
        width:{
            type: String,
            default: "500px"
        } 
    }
};
</script>
